import * as React from 'react';
import { FormattedMessage } from 'react-intl';

export const opts: number[] = [10, 9, 8, 7, 6, 5, 4, 3];

export const optFormatter = (n: string | number): React.JSX.Element => (
  <FormattedMessage id={`functionalPerformance.opts.modifiedChildrensGlobalAssessmentScale.rating.${n}`} />
);
